<template>
    <div class="camp-segrow">
        <div class="flex items-baseline justify-between gap-3">
            <span class="body-small text-ink">{{ label }}</span>
            <span class="details text-ink-muted shrink-0">{{ formatNumber(avg, "two-decimals") || "—" }}</span>
        </div>
        <div v-if="total > 0" class="camp-seg">
            <span
                v-for="(count, i) in distribution"
                :key="i"
                class="camp-seg__part"
                :class="{ 'camp-seg__part--dark': isLightSwatch(i) }"
                :style="{ width: `${percent(count)}%`, background: SEGMENT_COLORS[i] }">
                <template v-if="percent(count) >= 8">{{ formatNumber(percent(count) / 100, "percent") }}</template>
            </span>
        </div>
        <div v-else class="details text-ink-muted">{{ t("reflections.campaignReport.noResponses") }}</div>
    </div>
</template>

<script setup lang="ts">
import { LIGHT_SWATCH_INDICES, SEGMENT_COLORS } from "~vue/pages/reflections/campPalette";
import { formatNumber } from "~vue/utils/formatNumber";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
    label: string;
    // Distribution buckets: [rarely, occasionally, sometimes, often, consistently].
    distribution: number[];
    avg: number | null;
}

const props = defineProps<Props>();
const { t } = useI18n();

const total = computed(() => props.distribution.reduce((sum, n) => sum + n, 0));

function percent(count: number): number {
    if (!total.value) {
        return 0;
    }
    return Math.round((count / total.value) * 100);
}

function isLightSwatch(index: number): boolean {
    return LIGHT_SWATCH_INDICES.has(index);
}
</script>

<style scoped>
.camp-segrow {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.camp-seg {
    display: flex;
    width: 100%;
    height: 30px;
    border-radius: 10px;
    overflow: hidden;
}

.camp-seg__part {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-scaffold, sans-serif);
    font-size: 12px;
    line-height: 18px;
    color: white;
    min-width: 0;
}

.camp-seg__part--dark {
    color: black;
}
</style>
